const uri = 'https://media.oss.leziedu.com/webapp/classroom/mylearn/wrong/';
interface SubjectListType {
  [key: number]: {
    name: string;
    color: string;
    bgColor: string;
    icon: string;
  };
}
export const subjectsInfo: SubjectListType = {
  1: {
    name: '语文',
    color: '#F96060',
    bgColor: '#FFF4F4',
    icon: uri + 'yuwen.png',
  },
  2: {
    name: '数学',
    color: '#0A76EF',
    bgColor: '#EDF9FA',
    icon: uri + 'shuxue.png',
  },
  3: {
    name: '英语',
    color: '#00BE71',
    bgColor: '#ECFCF6',
    icon: uri + 'yingyu.png',
  },
  4: {
    name: '物理',
    color: '#456FE4',
    bgColor: '#F5F5FC',
    icon: uri + 'wuli.png',
  },
  5: {
    name: '化学',
    color: '#4B79F3',
    bgColor: '#F4F7FC',
    icon: uri + 'huaxue.png',
  },
  6: {
    name: '生物',
    color: '#11A572',
    bgColor: '#F4FAFA',
    icon: uri + 'shengwu.png',
  },
  7: {
    name: '政治',
    color: '#D66021',
    bgColor: '#FFFAEE',
    icon: uri + 'zhengzhi.png',
  },
  8: {
    name: '历史',
    color: '#D66021',
    bgColor: '#FFF4ED',
    icon: uri + 'lishi.png',
  },
  9: {
    name: '地理',
    color: '#488719',
    bgColor: '#ECFAEE',
    icon: uri + 'dili.png',
  },
};
interface FilterDateType {
  [key: string]: {
    title: string;
    value: string | number;
  };
}
export const filterDate: FilterDateType = {
  today: {
    title: '今日',
    value: 'today',
  },
  yesterday: {
    title: '昨日',
    value: 'yesterday',
  },
  week: {
    title: '7日内',
    value: 'week',
  },
  month: {
    title: '30日内',
    value: 'month',
  },
  term: {
    title: '本学期',
    value: 'term',
  },
};

export const filterDegree: FilterDateType = {
  0: {
    title: '不懂',
    value: 0,
  },
  30: {
    title: '了解',
    value: 30,
  },
  50: {
    title: '熟悉',
    value: 50,
  },
  100: {
    title: '熟练',
    value: 100,
  },
};
